import { download, generateCsv, mkConfig } from "export-to-csv"
import { DateTime } from "luxon"
import { useCallback } from "react"
import { useDateTime } from "../../../../localization/useDateTime"
import { WeekDayOccupancyRate } from "../statisticsTypes"

type useExportPeakHoursToCsvParams = Readonly<{
    data: WeekDayOccupancyRate[] | null | undefined
    startDate: DateTime
    endDate: DateTime
}>

export function useExportPeakHours({ data, startDate, endDate }: useExportPeakHoursToCsvParams) {
    const dateTimeFactory = useDateTime()

    const csvOptions = mkConfig({
        fieldSeparator: ";",
        quoteStrings: true,
        decimalSeparator: ".",
        useBom: true,
        useKeysAsHeaders: true,
        filename: `Facilitynet-peak-hours-${dateTimeFactory.formatDate(startDate)}_${dateTimeFactory.formatDate(endDate)}`,
    })

    const mapEntryToCsvRow = () => {
        if (!data) return []

        return data.flatMap((dayRate) =>
            dayRate.hourlyOccupancyRates.map((hourSlot) => ({
                "Week Day": dayRate.displayWeekDay,
                From: hourSlot.timeSlot.start,
                To: hourSlot.timeSlot.end,
                "Occupancy Rate (%)": hourSlot.occupancyRate.toFixed(1),
            })),
        )
    }

    return useCallback(() => {
        const rows = mapEntryToCsvRow()
        const csv = generateCsv(csvOptions)(rows)
        download(csvOptions)(csv)
    }, [dateTimeFactory, data, startDate, endDate])
}
